import axios from "axios";
import { baseApiUrl } from "../config";
import { readCookie } from "../utils";
import { unauthenticatedError } from "../helpers/errors";

axios.defaults.withCredentials = true;

export const httpGet = async (url, params) => {
    try {
        return await axios({
            method: 'GET',
            url: baseApiUrl + url,
            params,
            headers: {
                'X-XSRF-TOKEN': readCookie('XSRF-TOKEN'),
                Authorization: `Bearer ${readCookie('bearer_token')}`
            }
        })
    } catch (error) {
        if (error.response) {
            if (error.response.status === 401) {
                unauthenticatedError();
            }
            throw error.response;
        } else {
            throw error.message;
        }
    } finally {
        //
    }
};

export const httpPost = async (url, data) => {
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
    const headers = {
        'X-XSRF-TOKEN': readCookie('XSRF-TOKEN'),
        Authorization: `Bearer ${readCookie('bearer_token')}`
    };

    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
    }

    try {
        return await axios({
            method: 'POST',
            url: baseApiUrl + url,
            data,
            headers
        })
    } catch (error) {
        if (error.response) {
            if (error.response.status === 401) unauthenticatedError();
            throw error.response;
        } else {
            throw error.message;
        }
    } finally {
        //
    }
};

export const httpDelete = async (url, data) => {
    try {
        return await axios( {
            method: 'DELETE',
            url: baseApiUrl + url,
            data,
            headers: {
                'X-XSRF-TOKEN': readCookie('XSRF-TOKEN'),
                Authorization: `Bearer ${readCookie('bearer_token')}`
            }
        })
    } catch (error) {
        if (error.response) {
            if (error.response.status === 401) unauthenticatedError();
            throw error.response;
        } else {
            throw error.message;
        }
    } finally {
        //
    }
};
